import TextureExecutiveSummary from './TextureExecutiveSummary';
export default TextureExecutiveSummary;
